import React, { Dispatch, SetStateAction } from 'react';
import Box from '@mui/material/Box';
import { classes } from '../styles';
import { DebouncedFormTextField } from '../../../Components/CustomUIElements/FormTextField';

export default function Revolve({
  revolveTabJobData,
  setRevolveTabJobData,
  setIsEdited
}: {
  revolveTabJobData: {
    revolve_position_title: {
      error: string;
      required: boolean;
      value: string;
    };
  } | null;
  setRevolveTabJobData: Dispatch<
    SetStateAction<{
      revolve_position_title: {
        error: string;
        required: boolean;
        value: string;
      };
    } | null>
  >;
  setIsEdited: Dispatch<SetStateAction<boolean>>;
}) {
  return (
    <Box sx={classes.tabContent}>
      <Box id="template-title" sx={classes.headerContent}>
        Revolve
      </Box>
      <Box sx={classes.bodyContainer}>
        <Box sx={classes.modalFormLine}>
          <DebouncedFormTextField
            onDebouncedChange={(value) => {
              setRevolveTabJobData((prev) => {
                if (!prev) return null;
                return {
                  ...prev,
                  revolve_position_title: { ...prev.revolve_position_title, value: String(value) }
                };
              });
              setIsEdited(true);
            }}
            id="revolve"
            label="Position title"
            defaultValue={revolveTabJobData?.revolve_position_title?.value}
            required={revolveTabJobData?.revolve_position_title?.required}
            error={revolveTabJobData?.revolve_position_title?.error}
            styles={{ width: '250px' }}
          />
        </Box>
      </Box>
    </Box>
  );
}
